import React from 'react';
import MasterCrud from './MasterCrud';

/**
 * Vendor / sub-contractor master (Item 7). The "Discount %" here (defaultDeductionPct) is the single
 * source of truth for a sub's settlement deduction — it defaults into each weekly PO/settlement.
 * Booleans (customer/active) use boolean option values so the edit dialog reflects the stored value.
 */
export default function Vendors() {
  return (
    <MasterCrud
      title="Vendors"
      endpoint="/api/master/vendors"
      columns={[
        { key: 'displayName', label: 'Name' },
        { key: 'vendorType', label: 'Type' },
        { key: 'city', label: 'City' },
        { key: 'state', label: 'State' },
        { key: 'phone', label: 'Phone' },
        { key: 'defaultDeductionPct', label: 'Discount %' },
        { key: 'active', label: 'Active', render: (r) => (r.active ? 'Yes' : 'No') },
      ]}
      formFields={[
        { key: 'displayName', label: 'Display Name', required: true,
          helperText: 'Name shown on POs & settlements' },
        { key: 'vendorType', label: 'Type', type: 'select', options: [
          { value: 'SUB', label: 'Sub Contractor' },
          { value: 'COMPANY', label: 'Company' },
          { value: 'OWNER_OP', label: 'Owner-Operator' },
        ] },
        { key: 'companyName', label: 'Company Name' },
        { key: 'firstName', label: 'First Name' },
        { key: 'lastName', label: 'Last Name' },
        { key: 'defaultDeductionPct', label: 'Discount % (settlement deduction)', type: 'number',
          helperText: 'Default % deducted from this sub’s weekly PO (overridable per settlement)' },
        { key: 'tax1Pct', label: 'Specific Tax 1 %', type: 'number' },
        { key: 'tax2Pct', label: 'Specific Tax 2 %', type: 'number' },
        { key: 'creditLimit', label: 'Credit Limit', type: 'number' },
        { key: 'phone', label: 'Phone' },
        { key: 'email', label: 'Email', type: 'email' },
        { key: 'addressLine1', label: 'Address Line 1' },
        { key: 'addressLine2', label: 'Address Line 2' },
        { key: 'city', label: 'City' },
        { key: 'state', label: 'State' },
        { key: 'postalCode', label: 'Postal Code' },
        { key: 'country', label: 'Country' },
        { key: 'customer', label: 'Also a customer?', type: 'select', options: [
          { value: false, label: 'No' },
          { value: true, label: 'Yes' },
        ] },
        { key: 'active', label: 'Active', type: 'select', options: [
          { value: true, label: 'Yes' },
          { value: false, label: 'No' },
        ] },
      ]}
    />
  );
}
